// extracted by mini-css-extract-plugin
module.exports = {"module":"StatusWithIcon_module__35K26","positive":"StatusWithIcon_positive__rNGUz","negative":"StatusWithIcon_negative__1etJE"};